import React, { useContext, useCallback } from 'react';
import { useHistory } from 'react-router';
import FormHeader from 'components/Form/Header';
import EmailForm from 'components/Form/Email';
import { LoginContext } from './LoginContext';

const LoginEmailPage = ({ match }) => {
  const history = useHistory();
  const { email, setEmail } = useContext(LoginContext);

  const onSubmit = useCallback(
    (value) => {
      setEmail(value);
      history.push(`${match.url}/password`);
    },
    [history, match.url, setEmail],
  );

  return (
    <>
      <FormHeader title="Login" description="Enter your email" />
      <EmailForm
        initialValue={email}
        placeholder="E-mail"
        invalidMessage="Invalid email"
        buttonLabel="Next"
        onSubmit={onSubmit}
      />
    </>
  );
};

export default LoginEmailPage;
